import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {

  constructor(private http: HttpClient) { }

  downloadDocumentFileInfringement(mdmid: string) {
    return this.http.get(`/Document/GetInfringementPdf?userRutDv=${mdmid}`, {
      responseType: 'blob',
    });
  }

  downloadDocumentFileLicence(licenceId: number) {
    return this.http.get(`/Document/GetLicensePdf?licenseId=${licenceId}`, {
      responseType: 'blob',
    });
  }
  downloadDocumentFilePocketLicence(licenceId: number) {
    return this.http.get(`/Document/GetPocketLicensePdf?licenseId=${licenceId}`, {
      responseType: 'blob',
    });
  }

}
